'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AlertService = function () {
  function AlertService($http) {
    'ngInject';

    _classCallCheck(this, AlertService);

    this.$http = $http;
  }

  _createClass(AlertService, [{
    key: 'getAlerts',
    value: function getAlerts() {
      return this.$http.get('/api/alert/load_alert');
    }
  }]);

  return AlertService;
}();

exports.default = AlertService;


// WEBPACK FOOTER //
// ./services/alert.service.js